module.exports = __webpack_public_path__ + "img/ccwl-4.7ed25fbc.png";